import React from 'react';
import { Semester } from '../../types/grades';
import { GraduationCap, Plus, Minus } from 'lucide-react';
import { Card } from '../layout/Card';

interface SemesterListProps {
  semesters: Semester[];
  selectedSemesterId: string;
  onSelectSemester: (id: string) => void;
  onAddSemester: () => void;
  onRemoveSemester: (id: string) => void;
}

export function SemesterList({
  semesters,
  selectedSemesterId,
  onSelectSemester,
  onAddSemester,
  onRemoveSemester
}: SemesterListProps) {
  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">My Semesters</h2>
        <button
          onClick={onAddSemester}
          className="p-2 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
          title="Add semester"
        >
          <Plus size={20} />
        </button>
      </div>
      
      <div className="space-y-2">
        {semesters.map((semester) => (
          <div
            key={semester.id}
            className={`flex items-center justify-between p-2 rounded-md cursor-pointer 
                       transition-colors ${
                         semester.id === selectedSemesterId
                           ? 'bg-blue-50 text-blue-600'
                           : 'hover:bg-gray-50'
                       }`}
            onClick={() => onSelectSemester(semester.id)}
          >
            <div className="flex items-center gap-2">
              <GraduationCap size={16} />
              <span>{semester.name}</span>
            </div>
            {semesters.length > 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveSemester(semester.id);
                }}
                className="p-1 text-red-600 hover:bg-red-50 rounded-full transition-colors"
                title="Remove semester"
              >
                <Minus size={16} />
              </button>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}